export const fmtL = (n) => {
  const v = Number(n || 0);
  return new Intl.NumberFormat("es-HN", {
    style: "currency",
    currency: "HNL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v).replace("HNL", "L.");
};

export const fmtUSD = (n) => `US$ ${new Intl.NumberFormat("es-HN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n || 0))}`;
// Importe en la moneda indicada (HNL → L., USD → US$)
export const fmtMon = (n, moneda) => (String(moneda || "HNL").toUpperCase() === "USD" ? fmtUSD(n) : fmtL(n));

export const fmtNum = (n) =>
  new Intl.NumberFormat("es-HN", { maximumFractionDigits: 2 }).format(Number(n || 0));

// "AAAA-MM-DD" (fecha sin hora) se interpreta como fecha local: new Date("2027-01-20") es medianoche UTC,
// que en Honduras (UTC-6) se mostraba como el día anterior.
export const parseFecha = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || "").trim());
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(iso);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = parseFecha(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleDateString("es-HN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("es-HN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const apiErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Error desconocido";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === "object" ? x.msg : x)).join(", ");
  return String(d);
};

// Descripción comercial de una línea de venta (la impresa): sin «LOTE: …» ni «BATCH: …».
// El lote y el batch se conservan en la línea y en el inventario (trazabilidad). Igual que backend/texto_comercial.py
const LOTE_RX = /[\s;,|/-]*\b(?:LOTE|LOT|BATCH)\s*(?:N[°º.o]?\s*)?[:#]\s*[^\s;,]+/gi;
export const descripcionComercial = (t) => {
  const s = String(t || "");
  const limpio = s.replace(LOTE_RX, "").replace(/^[\s;,|-]+|[\s;,|-]+$/g, "");
  return limpio || s.trim();
};
// Los marcadores de lote / batch de la descripción (solo para mostrarlos como dato interno)
export const lotesDeDescripcion = (t) => (String(t || "").match(LOTE_RX) || []).map((x) => x.replace(/^[\s;,|/-]+/, "")).join(" · ");
